define("shared/components/shared/media-items/media-item", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="cLIB--boardItem">
    <figure class="o--mediaContainer">
      {{#if @mediaItem.isUploading}}
        <div class="e--upload-progress"></div>
      {{else}}
        <Shared::Image
          @picture={{hash sources=@mediaItem.medThumbnailOrProcessingUrl}}
          alt={{t "post.change_media.media_item_alt"}}
          class="o--media"
          data-type={{@mediaItem.mediaType}}
          {{draggable
            model=@mediaItem
            cssClassName="is--dragStart"
            droppableClassName="drop_spot"
            onDragStart=this.dragStart
            onDragEnd=this.dragEnd
          }}
        />
  
        {{! Media Info }}
        {{#if @mediaItem.needsApproval}}
          <span class="o--mediaOverlay">
            <span class="img--overlay__pending"></span>
          </span>
        {{/if}}
        {{#if @mediaItem.isVideo}}
          <span class="o--media__label--type">
            {{svg-jar "video" class="o--icon--md o--icon--white"}}
          </span>
        {{/if}}
        {{#if @mediaItem.isGif}}
          <span class="o--media__label--type">
            {{svg-jar "gif" class="o--icon--md o--icon--white"}}
          </span>
        {{/if}}
        {{#if @mediaItem.hasPosts}}
          <span class="o--media__label--status">
            {{@mediaItem.postCount}}
          </span>
        {{/if}}
      {{/if}}
    </figure>
  </li>
  */
  {
    "id": "ZFegrBp0",
    "block": "[[[10,\"li\"],[14,0,\"cLIB--boardItem\"],[12],[1,\"\\n  \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n\"],[41,[30,1,[\"isUploading\"]],[[[1,\"      \"],[10,0],[14,0,\"e--upload-progress\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,1],[[16,\"alt\",[28,[37,2],[\"post.change_media.media_item_alt\"],null]],[24,0,\"o--media\"],[16,\"data-type\",[30,1,[\"mediaType\"]]],[4,[38,4],null,[[\"model\",\"cssClassName\",\"droppableClassName\",\"onDragStart\",\"onDragEnd\"],[[30,1],\"is--dragStart\",\"drop_spot\",[30,0,[\"dragStart\"]],[30,0,[\"dragEnd\"]]]]]],[[\"@picture\"],[[28,[37,3],null,[[\"sources\"],[[30,1,[\"medThumbnailOrProcessingUrl\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,1,[\"needsApproval\"]],[[[1,\"        \"],[10,1],[14,0,\"o--mediaOverlay\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"img--overlay__pending\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"isVideo\"]],[[[1,\"        \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"video\"],[[\"class\"],[\"o--icon--md o--icon--white\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"isGif\"]],[[[1,\"        \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"gif\"],[[\"class\"],[\"o--icon--md o--icon--white\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"hasPosts\"]],[[[1,\"        \"],[10,1],[14,0,\"o--media__label--status\"],[12],[1,\"\\n          \"],[1,[30,1,[\"postCount\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@mediaItem\"],false,[\"if\",\"shared/image\",\"t\",\"hash\",\"draggable\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/media-items/media-item.hbs",
    "isStrictMode": false
  });
  let MediaItemComponent = _exports.default = (_class = class MediaItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _defineProperty(this, "dragImage", undefined);
    }
    dragStart(event) {
      event.dataTransfer.setData('type', this.args.mediaItem.mediaType);
      event.dataTransfer.setData('id', this.args.mediaItem.id);

      // Custom drag feedback image
      this.dragImage = new Image(50, 50);
      this.dragImage.src = event.target.src;
      this.dragImage.style = 'border: 4px solid white';
      document.body.appendChild(this.dragImage); // HTML drag and drop spec requires node to be visible on page

      this.logMissingMethods(event);
      event.dataTransfer?.setDragImage(this.dragImage, 40, 10);
    }
    dragEnd() {
      if (this.dragImage) {
        document.body.removeChild(this.dragImage);
        this.dragImage = undefined;
      }
    }
    logMissingMethods(event) {
      if (!event.dataTransfer.setDragImage) {
        this.errors.log('setDragImage is not a function. User might be using tampermonkey chrome extension.', {
          dataTransfer: event.dataTransfer
        }, 'info');
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "dragStart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dragStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragEnd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dragEnd"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaItemComponent);
});